import { LineType, TooltipShowRule } from 'klinecharts';

const CANDLE_BAR = {
  upColor:             '#26a69a',
  downColor:           '#ef5350',
  noChangeColor:       '#9598a1',
  upBorderColor:       '#26a69a',
  downBorderColor:     '#ef5350',
  noChangeBorderColor: '#9598a1',
  upWickColor:         '#26a69a',
  downWickColor:       '#ef5350',
  noChangeWickColor:   '#9598a1',
};

export function buildStyles(dark: boolean) {
  const gridColor    = dark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.06)';
  const tickColor    = '#787b86';
  const axisColor    = dark ? '#2a2e39' : '#e0e3eb';
  const crossColor   = '#787b86';
  const crossTextBg  = dark ? '#363a45' : '#e1e3ea';
  const crossTextClr = dark ? '#d1d4dc' : '#131722';

  return {
    candle:    { bar: CANDLE_BAR, tooltip: { showRule: TooltipShowRule.None, offsetLeft: 2, offsetTop: 26 } },
    indicator: { tooltip: { showRule: TooltipShowRule.None } },
    grid: {
      horizontal: { color: gridColor },
      vertical:   { color: gridColor },
    },
    xAxis: {
      tickText: { color: tickColor },
      axisLine: { color: axisColor },
    },
    yAxis: {
      tickText: { color: tickColor },
      axisLine: { color: axisColor },
    },
    crosshair: {
      horizontal: {
        line: { color: crossColor, style: LineType.Dashed },
        text: { backgroundColor: crossTextBg, color: crossTextClr },
      },
      vertical: {
        line: { color: crossColor, style: LineType.Dashed },
        text: { backgroundColor: crossTextBg, color: crossTextClr },
      },
    },
  };
}
